<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
                :page.sync="page"
               v-if="reWrite"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">

      <template slot="projectIdSearch">
        <el-select v-model="form.projectId" placeholder="项目名称" @change="changeHandler">
          <el-option
            v-for="(item,index) in projectIdList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>

      <template slot-scope="scope" slot="menu">
        <!-- <el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.approvereBtn"
          @click="openApprovereDialog(scope.row)">
          查看
        </el-button> -->
        <el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.approvereBtn"
          @click="openCourse(scope.row)">
          历程
        </el-button>
        <!-- <el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.approvereBtn&&(scope.row.abnormalType==1||scope.row.abnormalType==2||scope.row.abnormalType==3||scope.row.abnormalType==6)"
          @click="openApprovereDialog(scope.row)">
          审批
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.approvereBtn&&scope.row.abnormalType==5"
          @click="openApprovereDialog(scope.row)">
          提醒
        </el-button> -->
      </template>
      <template slot="areaIdSearch">
        <!-- v-show="areaIdFlag" slot-scope="{disabled,size}" -->
        <el-select
          v-model="form.areaId"
          :value="form.areaId"
          placeholder="需求区域"
          clearable
          style="width: 100%;"
          ref="connectSelect"
          name="connectSelect"
          @clear="clearSelectHandler"
        >
          <el-option :value="form.areaId" show-all-levels :label="form.areaName">
            <el-tree
              node-key="id"
              :data="treeFormAreaData"
              :props="treeProps"
              :load="editAreaLazyLoadTree"
              lazy
              @node-click="editAreaNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>

      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.orderapproverecord_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot="workStatus" slot-scope="scope">
        <el-tag type="success">{{ tool.getDictionaryValue(workStatusList,'dictValue','dictKey',scope.row.workStatus) }}</el-tag>
      </template>
      <template slot="workStatus" slot-scope="scope">
        <el-tag type="success">{{ tool.getDictionaryValue(workStatusList,'dictValue','dictKey',scope.row.workStatus) }}</el-tag>
      </template>
    </avue-crud>
    <el-dialog
      title="审批"
      :visible.sync="approvereShowDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="approvereFormRef"
          v-model="approvereForm"
          :option="approvereOption"
          @reset-change="approvereReset"
          @submit="approvereSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitApprovereDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>

    <courseCleanKeeping
        ref="courseCleanKeeping"

    ></courseCleanKeeping>
    <courseEquipmentInspection
        ref="courseEquipmentInspection"

    ></courseEquipmentInspection>
    <courseEquipmentMaintenance ref="courseEquipmentMaintenance"></courseEquipmentMaintenance>
    <courseUsecar ref="courseUsecar"></courseUsecar>
    <courseComplaints ref="courseComplaints"></courseComplaints>
    <courseEscort ref="courseEscort"></courseEscort>
    <courseRepair ref="courseRepair"></courseRepair>
    <courseSecurity ref="courseSecurity"></courseSecurity>
    <courseTransport ref="courseTransport"></courseTransport>
    <courseAreaInspection ref="courseAreaInspection"></courseAreaInspection>
    <courseComprehensiveInspection
   
      ref="courseComprehensiveInspection"
      @refresh="onLoad"
    ></courseComprehensiveInspection>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/api/crmedical/order/abnormal-order";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import {lazyAreaTree, getDictData} from "@/api/crmedical/order/order-list/order-list";
  import {audit} from "@/api/crmedical/order/orderapproverecord";
  import approvereOption from "./approvereOption";


    import courseCleanKeeping from "./order-list/course-cleanKeeping";//保洁服务
    import courseEquipmentInspection from "./order-list/course-equipment-inspection";//设备巡检
    import courseEquipmentMaintenance from "./order-list/course-equipment-maintenance";//设备维保服务
    import courseUsecar from "./order-list/course-usecar";//用车服务
    import courseComplaints from "./order-list/course-complaints";//投诉监督
    import courseEscort from "./order-list/course-escort";//陪护服务
    import courseRepair from "./order-list/course-repair";//报修服务
    import courseSecurity from "./order-list/course-security";//保安服务
    import courseTransport from "./order-list/course-transport";//运送服务
    import courseAreaInspection from "./order-list/course-area-inspection";//区域巡检
  // import {getProjectList} from "@/api/crmedical/group/group";
import courseComprehensiveInspection from "./order-list/course-comprehensive-inspection"; //综合巡检
  export default {
      components:{
          courseCleanKeeping,
          courseEquipmentInspection,
          courseEquipmentMaintenance,
          courseUsecar,
          courseComplaints,
          courseEscort,
          courseRepair,
          courseSecurity,
          courseTransport,
          courseAreaInspection,courseComprehensiveInspection
      },
    data() {
      return {
        treeProps: {
          //标题
          label: 'name',
          //值
          value: 'id',
          //子节点
          children: 'zones',
          //是否叶子节点
          isLeaf: 'hasChildren',
          //本节点类型key值
          objectType: 'id',
          //本节点类型名
          objectTypeName: 'name',
        },
        workStatusList:[],//工单状态
        treeFormAreaData: [],
        projectFlag: true,
        projectIdList: [],//项目下拉框
        approvereOption: approvereOption,
        isApprovereDialogFirstOpen: true,
        approvereShowDialogFlag: false,
        approvereForm: {},
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        reWrite: true,
        selectionList: [],
        temProjectId: "",
        option: {
          tip: false,
          tree: true,
          searchShow: true,
          searchMenuSpan: 24,
          height: "auto",
          calcHeight: 100,
          border: true,
          index: false,
          viewBtn: true,
          labelWidth: 180,
          selection: false,
          addBtn: true,
          return_visitBtn: true,
          columnBtn: false,
          refreshBtn: false,
          align: "left",
          approvereBtn: true,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: 'select',
              search: true,
              hide: false,
              searchslot: true,
              dicUrl: '/api/v4ward/project/getProjectList',
              props: { label: 'name', value: 'id' },
            },
            {
              label: "工单编号",
              prop: "code",
              search: true,
              rules: [
                {
                  required: true,
                  message: "请输入工单编号",
                  trigger: "change"
                }
              ]
            },
            {
              label: "工单类型",
              prop: "moduleType",
              type: "select",
              search: true,
              dataType: 'number',
              dicUrl: "/api/blade-system/dict/dictionary?code=module_type",
              dicData: [],
              props: {
                label: "dictValue",
                value: "dictKey",
              },
              rules: [
                {
                  required: false,
                  message: "请选择工单类型",
                  trigger: "change",
                },
              ],
            },
            {
              label: "需求区域",
              prop: "areaName",
              // search: true,
            },
            {
              label: "需求区域",
              prop: "areaId",
              hide: true,
              search: true,
              searchslot: true,
            },

            {
              label: "期望到场日期",
              prop: "expectStartTime",
              labelWidth: 120,
              type: "datetime",
              format: "yyyy-MM-dd",
              valueFormat: "yyyy-MM-dd",
              rules: [
                {
                  required: false,
                  message: "请输入有效期起",
                  trigger: "change",
                },
              ],
            },

            {
              label: "责任人",
              prop: "handerName",
              search: true,
              rules: [
                {
                  required: false,
                  message: "请输入责任人姓名",
                  trigger: "change",
                },
              ],
            },
            {
              label: "需求人",
              prop: "requireManName",
              search: true,
              rules: [
                {
                  required: false,
                  message: "请输入需求人姓名",
                  trigger: "change",
                },
              ],
            },
            {
              label: "联系方式",
              prop: "requireManPhone",
              search: true,
              rules: [
                {
                  required: false,
                  message: "请输入需求人联系方式",
                  trigger: "change",
                },
              ],
            },

            {
              label: "工单状态",
              prop: "workStatus",
              type: "select",
              search: false,
              slot: true,
              dataType: 'number',
              dicUrl: "/api/blade-system/dict/dictionary?code=order_work_status",
              dicData: [],
              props: {
                label: "dictValue",
                value: "dictKey",
              },
              rules: [
                {
                  required: true,
                  message: "请选择工单状态",
                  trigger: "change"
                }
              ]
            },
            // {
            //   label: "审批类型",
            //   prop: "actionType",
            //   type: "select",
            //   search: false,
            //   dataType: 'number',
            //   dicUrl: "/api/blade-system/dict/dictionary?code=order_action",
            //   dicData: [],
            //   props: {
            //     label: "dictValue",
            //     value: "dictKey",
            //   },
            //   rules: [
            //     {
            //       required: true,
            //       message: "请选择审批类型",
            //       trigger: "change"
            //     }
            //   ]
            // },
            {
              label: "异常类型",
              prop: "abnormalType",
              type: "select",
              search: true,
              dataType: 'number',
              dicUrl: "/api/blade-system/dict/dictionary?code=order_abnormal_type",
              dicData: [],
              props: {
                label: "dictValue",
                value: "dictKey",
              },
              rules: [
                {
                  required: true,
                  message: "请选择审批类型",
                  trigger: "change"
                }
              ]
            },



            // {
            //   label: "审批状态",
            //   prop: "approveStatus",
            //   type: "select",
            //   search: false,
            //   dataType: 'number',
            //   dicUrl: "/api/blade-system/dict/dictionary?code=approve_status",
            //   dicData: [],
            //   props: {
            //     label: "dictValue",
            //     value: "dictKey",
            //   },
            //   rules: [
            //     {
            //       required: true,
            //       message: "请选择审批状态",
            //       trigger: "change"
            //     }
            //   ]
            // },

          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.orderapproverecord_add, false),
          viewBtn: this.vaildData(this.permission.orderapproverecord_view, false),
          delBtn: this.vaildData(this.permission.orderapproverecord_delete, false),
          editBtn: this.vaildData(this.permission.orderapproverecord_edit, false),
          approvereBtn: this.vaildData(this.permission.order_approvereBtn, true),

        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    /*created() {
      getProjectList().then((data) => {
        this.projectList = data.data;
        if (this.projectList.length > 0) {
          var projectColumn = this.findObject(this.option.column, 'projectId');
          projectColumn.dicData = data.data;
          projectColumn.searchValue = this.projectList[0].id;
          this.query.projectId = this.projectList[0].id;
          this.temProjectId = this.projectList[0].id;
          this.form.projectId = this.temProjectId;
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
        this.onLoad();
      });
    },*/
    created() {
      this.getDictionary()
    },
    mounted(){
      this.$refs.crud.$children[0].$el.querySelector('.avue-form__menu').style = 'text-align:right';
      this.$nextTick(() => {
              // this.reWrite = true;
              console.log(this.bodyHeight);
              setTimeout(()=>{
              console.log(this.$refs.crud)
              console.log(this.$refs.crud.$children[1].$children.length);
              let arrLength = this.$refs.crud.$children[1].$children.length;
              console.log(this.$refs.crud.$children[1].$children[arrLength-2].$el);
              this.$refs.crud.$children[1].$children[arrLength-2].$el.addEventListener("click", ()=>{
                // console.log(1212121)
                console.log("this.option.height=====>",this.option.height);
                    if(this.option.height == this.bodyHeight - 284){
                      this.option.height = this.bodyHeight - 453
                    }else{
                      this.option.height = this.bodyHeight - 284;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
            });
    },
    activated(){
                    this.$refs.crud.doLayout();
    },
    deactivated(){
                    this.$refs.crud.doLayout();
    },
    methods: {
        clearSelectHandler(){

          console.log('66666');
          setTimeout(()=>{
            document.querySelector('input[name=connectSelect]').value = '';
            Object.assign({},this.form,{areaName:'',areaId:''});
          })
        },
        // 打开历程弹窗
        openCourse(row){
              // courseCleanKeeping, 1
              // courseEquipmentInspection,9
              // courseEquipmentMaintenance,8
              // courseUsecar,6
              // courseComplaints,5
              // courseEscort,3
              // courseRepair,7
              // courseSecurity,2
              // courseTransport,4
              // courseAreaInspection 10
            switch(parseInt(row.moduleType)){
                case 1:
            this.$refs.courseCleanKeeping.getDictionary().then(()=>{
                  this.$refs.courseCleanKeeping.openDialog(row);
                  });
                  break;
                case 2:
            this.$refs.courseSecurity.getDictionary().then(()=>{
                  this.$refs.courseSecurity.openDialog(row);
                  });
                  break;
                case 3:
            this.$refs.courseEscort.getDictionary().then(()=>{
                  this.$refs.courseEscort.openDialog(row);
                  });
                  break;
                case 4:
            this.$refs.courseTransport.getDictionary().then(()=>{
                  this.$refs.courseTransport.openDialog(row);
                  });
                  break;
                case 5:
            this.$refs.courseComplaints.getDictionary().then(()=>{
                  this.$refs.courseComplaints.openDialog(row);
                  });
                  break;
                case 6:
            this.$refs.courseUsecar.getDictionary().then(()=>{
                  this.$refs.courseUsecar.openDialog(row);
                  });
                  break;
                case 7:
            this.$refs.courseRepair.getDictionary().then(()=>{
                  this.$refs.courseRepair.openDialog(row,false);
                  });
                  break;
                case 8:
            this.$refs.courseEquipmentMaintenance.getDictionary().then(()=>{
                  this.$refs.courseEquipmentMaintenance.openDialog(row);
                  });
                  break;
                case 9:
            this.$refs.courseEquipmentInspection.getDictionary().then(()=>{
                  this.$refs.courseEquipmentInspection.openDialog(row);
                  });
                  break;
                case 10:
            this.$refs.courseAreaInspection.getDictionary().then(()=>{
                  this.$refs.courseAreaInspection.openDialog(row);
                  });
                  case 11:
            this.$refs.courseComprehensiveInspection.getDictionary().then(() => {
              let obj = Object.assign({},row)
              obj.orderId = row.id
              this.$refs.courseComprehensiveInspection.openDialog(obj);
            });
                  break;
                  case 12:
            this.$refs.courseRepair.getDictionary().then(()=>{
                  this.$refs.courseRepair.openDialog(row,false);
                  });
                  break;
                  case 13:
            this.$refs.courseRepair.getDictionary().then(()=>{
                  this.$refs.courseRepair.openDialog(row,false);
                  });
                  break;
            }
        },
      // 树加载完毕
      editAreaLazyLoadTree(node, resolve) {
        if (!this.form.projectId) return; // 如果没拿到项目id则等拿到项目id时再去获取树
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        lazyAreaTree({parentId: id, projectId: this.form.projectId}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          } else {

          }
          resolve(data);
        });
      },
      editAreaNodeTreeClick(node) {
        console.log('click')
        setTimeout(() => {
          let nodeId = node.id;
          let nodeTitle = node.name;
          // this.form.areaName = nodeTitle;
          // this.form.areaId = nodeId;

          this.form = Object.assign({}, this.form, {'areaName': nodeTitle, "areaId": nodeId});
          this.$refs.connectSelect.blur();
          this.areaNameFlag = true;
          this.areaIdFlag = false;
        }, 0);
      },
      changeHandler(value) {
        lazyAreaTree({parentId: 0, projectId: value}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          }
          this.form.areaName = '';
          this.form.areaId = '';
          this.treeFormAreaData = data;
        });
      },

      getDictionary() {
        //加载列表
        getProjectList({}).then((res) => {
          this.projectIdList = res.data;
          if (this.projectIdList.length > 0) {
            this.query.projectId = this.projectIdList[0].id;
            this.form.projectId = this.projectIdList[0].id;
            this.changeHandler(this.form.projectId); // 拿到项目id后触发获取需求区域
          }
          this.$nextTick(() => {
            this.reWrite = true;
          });
          // order_work_status 获取工单状态
          getDictData('order_work_status').then(res=>{
            this.workStatusList = res.data;

          })
        });

      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        // this.query = {projectId:this.projectIdList[0].id};
        // this.form.projectId = this.projectIdList[0].id;
        // // this.form.projectId = this.$refs.crud.
        // // console.log(this.$refs.crud);
        // // this.projectIdList.forEach((ele)=>{
        // //   this.form.projectId

      setTimeout(()=>{
        this.form = Object.assign({}, this.form, {
          areaName: '',
          areaId: '',
        });
      })
        // // });
        // this.form.projectId = this.projectIdList[0].id;
        // console.log(this.projectIdList[0].id);
        // this.query.projectId = this.form.projectId;
        this.form.areaId = '';
        this.form.areaName = '';
        Object.assign({},this.form,{areaId:'',areaName:''});
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.query.projectId = this.form.projectId;
        this.query.areaId = this.form.areaId;
        if(!this.query.projectId){
          this.query.projectId = this.projectIdList[0].id;
        }
        this.page.currentPage = 1;
        // this.onLoad();
        done()
        this.onLoad();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
          console.log("records======>",this.data);
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }).catch(err => {
          this.loading = false;
        })
      },
      //打开审批页面
      openApprovereDialog(row, flag) {

        if (row.approveStatus == 1 || row.approveStatus == 2) {
          console.log(row);
          this.$message.warning("该工单已审批！");
          return;
        }
        this.approvereShowDialogFlag = true;


        this.approvereForm.id = row.id;
        if (flag) {
          return;
        }


      },
      //退出审批页面
      quitApprovereDialog(form, done) {
        this.approvereShowDialogFlag = false;
        this.$refs.approvereFormRef.resetForm();
      },

      //审批数据保存
      approvereSubmit(form, done) {

        this.$refs.approvereFormRef.validate((valid) => {
          if (valid) {

            //调用审批接口
            audit(form).then(
              () => {
                this.onLoad();
                this.$message.success('操作成功!');
                this.approvereShowDialogFlag = false;
                this.$refs.approvereFormRef.resetForm();
                done();
              },
              (error) => {
                done();
                console.log(error);
              },
            );
          }
        });
      },
    }
  };
</script>

<style lang="scss" scoped>
::v-deep .avue-form__item--{
  width:100%;
}
</style>